module.exports = __webpack_public_path__ + "static/birthday-home-placeholder-a469a35309d73124a0396a3d8dd55922.png";